<app-stepper>
  <cdk-step
    [label]="'searchSubscription.stepper_title.desktop.step1' | i18n"
    [completed]="wasSuccessful"
    [editable]="!wasSuccessful"
  >
    <div class="step">
      <div class="step__main">
        <app-desktop-step-one></app-desktop-step-one>
      </div>

      <div class="step__footer">
        <div class="step-footer">
          <div class="step-footer__column step-footer__column--spacer"></div>

          <div class="step-footer__column">
            <button class="rounded-button" cdkStepperNext>
              <span class="rounded-button__label">
                {{ 'common.continue' | i18n }}
              </span>
              <i
                class="rounded-button__icon rounded-button__icon--suffix material-icon material-icon--white"
              >
                keyboard_arrow_right
              </i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </cdk-step>

  <cdk-step
    [label]="'searchSubscription.stepper_title.desktop.step2' | i18n"
    [completed]="wasSuccessful"
    [editable]="!wasSuccessful"
  >
    <div class="step">
      <div class="step__main">
        <app-desktop-step-two></app-desktop-step-two>
      </div>

      <div class="step__footer">
        <div class="step-footer">
          <div class="step-footer__column">
            <button
              class="rounded-button rounded-button--outlined"
              cdkStepperPrevious
            >
              <i
                class="rounded-button__icon rounded-button__icon--prefix material-icon material-icon--orange"
              >
                keyboard_arrow_left
              </i>
              <span class="rounded-button__label">
                {{ 'common.back' | i18n }}
              </span>
            </button>
          </div>

          <div class="step-footer__column step-footer__column--spacer"></div>

          <div class="step-footer__column">
            <button class="rounded-button" cdkStepperNext>
              <span class="rounded-button__label">
                {{ 'common.continue' | i18n }}
              </span>
              <i
                class="rounded-button__icon rounded-button__icon--suffix material-icon material-icon--white"
              >
                keyboard_arrow_right
              </i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </cdk-step>

  <cdk-step
    [label]="
      (wasSuccessful
        ? 'searchSubscription.stepper_title.desktop.step_final'
        : 'searchSubscription.stepper_title.desktop.step3'
      ) | i18n
    "
    [completed]="wasSuccessful"
    [editable]="!wasSuccessful"
  >
    <div class="step" *ngIf="!wasSuccessful">
      <div class="step__main">
        <app-desktop-step-three></app-desktop-step-three>
      </div>

      <div class="step__footer">
        <div class="step-footer">
          <div class="step-footer__column">
            <button
              class="rounded-button rounded-button--outlined"
              cdkStepperPrevious
            >
              <i
                class="rounded-button__icon rounded-button__icon--prefix material-icon material-icon--orange"
              >
                keyboard_arrow_left
              </i>
              <span class="rounded-button__label">
                {{ 'common.back' | i18n }}
              </span>
            </button>
          </div>

          <div class="step-footer__column step-footer__column--spacer"></div>

          <div class="step-footer__column step-footer__column--force-center">
            <button
              class="rounded-button"
              [disabled]="!canSubmit ? true : null"
              (click)="submit()"
            >
              <span class="rounded-button__label">
                {{ 'searchSubscription.save' | i18n }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="desktop-wizard__success-message" *ngIf="wasSuccessful">
      <lib-success-message>
        <a 
          class="mdc-button success-message__button" 
          [href]="objectSearchUrl"
        >
          <span class="mdc-button__ripple"></span>
          <span class="mdc-button__label">
            {{ 'searchSubscription.toObjectSearch' | i18n }}
          </span>
          <span class="mdc-button__touch"></span>
        </a>
      </lib-success-message>
    </div>
  </cdk-step>
</app-stepper>
